// Weekly outlooks
export const weeklyOutlooks = "weeklyOutlooks";

// Pending actions
export const pendingActions = "pendingActions";

// Banking institutions
export const bankingInstitutions = "bankingInstitutions";

// Spending category
export const spendingCategory = "spendingCategory";

// User session
export const userSession = "userSession";

// User account
export const userAccount = "userAccount";

// Budget
export const budget = "budget";
export const budgetTemplates = "budget/budgetTemplates";
// export const budgetTracking = "budget/budgetTracking";
